<template>
  <div class="feedback">
    <div class="seach">
      <el-row>
        <div class="seach-list r iblock">
          <el-input
            placeholder="请输入搜索内容"
            v-model="search.keywords"
            round
            class="input-with-select input-sea r"
          >
            <el-button slot="append" icon="el-icon-search" @click="seachList()"></el-button>
          </el-input>
        </div>
      </el-row>
    </div>
    <!-- //表格数据 -->
    <div class="list-wrap" v-if="resultData.list&&resultData.list.length>0" v-loading="tableLoading">
      <el-table
        ref="table"
        stripe
        :data="resultData.list"
        :header-cell-style="{backgroundColor:'#f5f7fa'}"
        style="width: 100%;margin: 20px 0;"
      >
        <el-table-column label="头像/昵称">
          <template slot-scope="scope">
            <div class="user-info">
              <img class="guests-avatar" :src="scope.row.user_pfrofile_photo" alt='' />
              <span class="vm">{{scope.row.user_nick_name}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="feedback_content" label="内容"></el-table-column>
        <el-table-column prop="mobile" label="联系方式"></el-table-column>
        <el-table-column prop="title" label="title"></el-table-column>
        <el-table-column prop="created_at" label="反馈时间"></el-table-column>
        <!-- <el-table-column prop="updated_at" label="最新回复时间"></el-table-column> -->
        <!-- <el-table-column prop="" label="状态">
          <template slot-scope="scope">
            <span v-show="scope.row.state==1">未回复</span>
            <span v-show="scope.row.state==2">已回复</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="respondMessage(scope.row,'3')">回复</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <div class="tc">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="Number(search.page)"
          :page-size="Number(search.size)"
          layout="total, prev, pager, next,jumper"
          :total="Number(resultData.count)"
        ></el-pagination>
      </div>
       <!-- //回复评论和消息推送的弹窗 -->
      <RespondMessage :respondVisible.sync="respondVisible" :resmessage="resmessage" :titleType="titleType" @uploadInfo="uploadInfo"></RespondMessage>
    </div>
  </div>
</template>

<script>
//引入回复评论和回复内容
import  RespondMessage from "./components/respond-message"
//反馈列表
import  {_userFeedbackList} from "@/api/user.js"

import user_mixins from './components/user-mixins'
export default {
  created() {
    this.userFeedbackList();
  },
  mixins:[user_mixins],
  components: {
    RespondMessage
},
  data() {
    return {
      tableLoading:false,
      search: {
        page:1,
        size:10,
        keywords:''
      },
      // name type num money date
      resultData: {
      }
    };
  },
  methods: {
    //查询信息
    seachList() {
      this.chearSearchState();
      this.userFeedbackList();
    },
    //翻页
    handleCurrentChange(val) {
      this.search.page = val
      this.userFeedbackList()
    },
    reply(item) {
      // this.privateDialogVisible = true;
    },
    uploadInfo(val){
      if(val){
        this.userFeedbackList();
      }
    },
      //加载列表
    userFeedbackList(){
      this.tableLoading=true;
      _userFeedbackList({
        params:{
          page:this.search.page,
          size:this.search.size,
          keywords:this.search.keywords,
        }
      }).then(res=>{
        this.tableLoading=false;
        if(res.resultCode==1){
          this.resultData=res.result;
        }else{
          this.$message.error(res.errorMsg);
        }
      })
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.feedback {
  .seach-list {
    .input-v {
      margin-left: 20px;
    }
    .input-sea {
      margin-left: 20px;
      width: 280px;
      border-radius: 5px;
    }
  }
}
.user-info {
  .guests-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-right: 20px;
    vertical-align: middle;
  }
}
</style>